import axios from "axios";
import { loginRefresh } from "./protectedClientHelper";

const optionalProtectedClient = axios.create({
  baseURL: process.env.REACT_APP_ADMIN_API_BASE_URI,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

optionalProtectedClient.interceptors.request.use(
  async (config) => {
    const tokenExpireAtString = localStorage.getItem("tokenExpireAt");
    const currentTime = new Date().getTime();

    if (tokenExpireAtString) {
      const tokenExpireAt = new Date(tokenExpireAtString);
      if (tokenExpireAt && currentTime > tokenExpireAt.getTime()) {
        const refreshTokenExpireAtString = localStorage.getItem("refreshTokenExpireAt");
        if (refreshTokenExpireAtString) {
          const refreshTokenExpireAt = new Date(refreshTokenExpireAtString);
          if (refreshTokenExpireAt && currentTime <= refreshTokenExpireAt.getTime()) {
            try {
              await loginRefresh();
            } catch (error) {
              // Optional endpoints should not trigger auth side effects.
            }
          }
        }
      }
    }

    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      config.headers["Authorization"] = `Bearer ${authToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default optionalProtectedClient;
